// src/components/SEOHead.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { 
  serviceSEO 
} from '../utils/SeoConfig'; 

import {getBreadcrumbStructuredData,getLocalBusinessStructuredData,getMetaTags,getSEOForPath, getServiceStructuredData,} from '../utils/SeoMappings';

const SEOHead = ({ customSEO, serviceSlug }) => {
  const location = useLocation();
  const path = location.pathname;
  
  // Get SEO data based on path or custom SEO
  const seo = customSEO || getMetaTags(path);
  
  // Get structured data
  const localBusinessData = getLocalBusinessStructuredData();
  const breadcrumbData = getBreadcrumbStructuredData(path);
  
  // Get service structured data if it's a service page
  const serviceData = path.startsWith('/services/') 
    ? serviceSEO[path.replace('/services/', '')] 
    : null;

  return (
    <Helmet>
      <title>{seo.title}</title>
      
      {/* Meta tags */}
      {seo.meta?.map((tag, index) => (
        <meta 
          key={index}
          {...(tag.name ? { name: tag.name } : { property: tag.property })}
          content={tag.content}
        />
      ))}
      
      {/* Link tags */}
      {seo.link?.map((link, index) => (
        <link 
          key={index}
          rel={link.rel}
          href={link.href}
        />
      ))}
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessData)}
      </script>
      
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
      
      {serviceData && (
        <script type="application/ld+json">
          {JSON.stringify(getServiceStructuredData(serviceData, path.replace('/services/', '')))}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;